export default __webpack_public_path__ + "images/product--without-prescription.svg?0562cd5e553457fe1dfa12ae37e4ad9d";